import React from 'react';

import { Customer, Order, ShippingCompany } from '../DriverScheduling/DriverScheduling';

import './styles.scss';
import { getDiffDaysFromToday } from '../../../../utils/dateUtilities';
import { MdCheckCircle } from 'react-icons/md';

interface DriverOrderProps {
  customer?: Customer;
  order?: Order;
  shippingCompany?: Partial<ShippingCompany[]>;
  product?: string;
  expirationDate?: string;
  qtyOrdered?: number;
  truckPlate?: string;
  onClick?: () => void;
  denyOrder: () => void;
  acceptOrder: (e: React.MouseEvent<Element>) => void;
  selected?: boolean;
}

export function DriverOrder({
  order,
  shippingCompany,
  expirationDate,
  qtyOrdered,
  customer,
  product,
  truckPlate,
  selected,
  onClick,
  denyOrder,
  acceptOrder,
}: DriverOrderProps) {
  const daysLeft = getDiffDaysFromToday(expirationDate);

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleDeny = (e: React.MouseEvent) => {
    stopPropagation(e);
    denyOrder();
  };

  const handleEnterQueue = (e: React.MouseEvent) => {
    stopPropagation(e);
    acceptOrder(e);
  };

  return (
    <div className="driver__order--wrapper">
      <div className={`driver__order--checkbox ${selected ? 'order-checked' : ''}`}>
        <MdCheckCircle />
      </div>

      <div className="driver__order" onClick={onClick}>
        <header className="driver__order--header">
          <p className="driver__order--code">
            Pedido <strong>{order?.code}</strong>
          </p>

          <div>
            <p className="driver__order--plate">{truckPlate}</p>
          </div>
        </header>

        <div className="driver__order--body">
          <div className="driver__order--block">
            <Show when={!!product} className="driver__order--item product">
              <p className="driver__order--title">Produto</p>
              <strong className="driver__order--description">
                {product} - {qtyOrdered}t
              </strong>
            </Show>

            <Show when={!!customer?.name} className="driver__order--item customer">
              <p className="driver__order--title">Cliente</p>
              <strong className="driver__order--description">{customer?.name}</strong>
            </Show>

            <Show when={shippingCompany?.length! > 0} className="driver__order--item transporter">
              <p className="driver__order--title">Transportadora</p>
              <strong className="driver__order--description">{shippingCompany?.map((company) => company?.name).join(', ')}</strong>
            </Show>
          </div>

          <Show when={!!daysLeft.value} className="driver__order--remaining-days">
            <p>Você tem</p>
            <p>
              <strong>{daysLeft.value}</strong> dias
            </p>
            <p>para entrar na fila virtual</p>
          </Show>
        </div>

        <footer className="driver__order--footer">
          <div className="driver__order--actions">
            <button type="button" className="driver__order--btn deny" onClick={handleDeny}>
              Recusar
            </button>

            <button type="button" className="driver__order--btn enter-queue orange" onClick={handleEnterQueue}>
              Entrar na fila
            </button>
          </div>
        </footer>
      </div>
    </div>
  );
}

type ShowProps = {
  when: boolean;
  Wrapper?: React.ElementType;
  fallback?: React.ReactNode;
  children: React.ReactNode;
} & React.ComponentProps<'div'>;

function Show({ Wrapper = 'div', fallback, when, children, ...rest }: ShowProps) {
  return (
    <Wrapper {...rest}>
      {when && children}

      {!when && fallback}
    </Wrapper>
  );
}
